<template>
  <div class="item-left">
    {{ name }}
  </div>
</template>

<script>
export default {
  props: {
    event: {}
  },

  computed: {
    name: function () {
      return this.event.get('name')
    }
  }
}
</script>
